import * as React from 'react'
import Grecaptcha from 'react-grecaptcha'
import FormGroup from './form-group'
import Errors from './errors'
import { get } from 'lodash'
import { withConfig } from '../../common/modules/config'
import { withErrors } from '../../common/modules/errors'
import { withFields } from '../../common/modules/fields'


@withConfig
@withErrors
@withFields
export default class extends React.Component<any, any>{

    render(){
        // Required
        const field = this.props.field;
        const siteKey = process.env.REACT_APP_RECAPTCHA;
        const errors = get( this.props.errors, field );
        const updateField = this.props.actions.fields.updateField;
        const show = this.props.show;

        if(!siteKey) throw("Config must have 'captchaKey' entry for Recaptcha component");

        const callback = (code) => {
            console.log("Recaptcha: " + code);
            updateField(field, code)
        }

        
        if(show == null || show){
            return (
                <div className="col-12">
                    <FormGroup field={ field } errors={ errors }>
                        <Grecaptcha
                            sitekey={ siteKey }
                            callback={ callback.bind(this) }
                            expiredCallback={ code => callback(null) }
                        />
                        <Errors errors={ errors } />
                    </FormGroup>
                </div>
            )
        }else{
            return null;
        }
    }

}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/recaptcha.tsx